import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'EMPLOYEE_PROFILE/TAGS';

export const {
    action: add,
    success: addSuccess,
    failed: addFailed,
} = createAction(
    `${domain}/ADD_TAG`,
    (employeeId: string, tagId: string) => ({employeeId, tagId}),
    (employeeId: string, tagId: string) => ({employeeId, tagId}),
    (employeeId: string, tagId: string) => ({employeeId, tagId}),
);

export const {
    action: remove,
    success: removeSuccess,
    failed: removeFailed,
} = createAction(
    `${domain}/REMOVE_TAG`,
    (employeeId: string, tagId: string) => ({employeeId, tagId}),
    (employeeId: string, tagId: string) => ({employeeId, tagId}),
    (employeeId: string, tagId: string) => ({employeeId, tagId}),
);
